export class HelpUtils {
  static isPresent(obj: any): boolean {
    return obj !== undefined && obj !== null && obj !== 'undefined';
  }

  static prepareTreeNodes(nodes: any) {
    const result: any[] = [];
    if (nodes && (nodes as any[]).length) {
      (nodes as any[]).forEach((value) => {
        const treeNode: any = {
          post: value.hasOwnProperty('posts') && value.posts?.length,
          label: value.name,
          dateCreate: value.created,
          dateUpdate: value.modified,
          data: value.description,
          mdsIcon: value.mds_icon,
          search_result: value.search_result,
          key: value.hasOwnProperty('posts') ? `category_${value.id}` : value.id, // для разделения id категорий и статей
          id: value.id,
          children: [],
        };
        if (value.icon && String(value.icon).trim().length) {
          if (String(value.icon).startsWith('http')) {
            treeNode.pic = value.icon;
          } else {
            treeNode.pic = `../../../assets/images/icons/help/${value.icon}.svg`;
          }
        }
        treeNode.children = [];
        treeNode.children.push(...HelpUtils.prepareTreeNodes(value.children));

        treeNode.children.push(...HelpUtils.prepareTreeNodes(value.posts));

        if (treeNode.data && String(treeNode.data).length && String(treeNode.data).includes('<tr>')) {
          treeNode.data = String(treeNode.data)
            .replace(new RegExp('<td>', 'g'), '<td><div></div><div class="table-row-custom">')
            .replace(new RegExp('</td>', 'g'), '</div></div></td>');
        }

        if (treeNode.key) {
          result.push(treeNode);
        }
      });
    }
    return result;
  }
}

export function isPresumedHTMLString(candidate) {
  const trimmed = candidate.trim();
  return trimmed.startsWith('<') && trimmed.endsWith('>');
}
